<script>
export default {
    name: "MyHealthMixin",
    methods: {
        listCon () {
            this.$http.get(this.route)
                .then(function (response) {
                    this.cons = response.data;
                    bus.$emit('listCon', this.cons);
                    if(this.cons.length > 0 && this.update) this.show(this.cons[0])
                }, (response) => {
                    this._handleErrors(response.data, '#con-form')
                })
        }
    }
}
</script>
